import { privateInstance, mapUrl } from "../configs";

export const invoiceApi = {
  async getInvoices() {
    const res = await privateInstance.get("/invoices/api/invoices/cl/");
    return res.data;
  },
  async retrieveInvoice(id) {
    const res = await privateInstance.get(`/invoices/api/invoices/rud/${id}/`);
    return res.data;
  },
  async postInvoice(invoice) {
    const res = await privateInstance.post(
      "/invoices/api/invoices/cl/",
      invoice
    );
    return res.data;
  },
  async putInvoice(id, invoice) {
    const res = await privateInstance.put(
      `/invoices/api/invoices/rud/${id}/`,
      invoice
    );
    return res.data;
  },
  async deleteInvoice(id) {
    await privateInstance.delete(`/invoices/api/invoices/rud/${id}/`);
  },
  async getOpenInvoicesForSupplier(supplierId, storeId) {
    const res = await privateInstance.get(
      `/invoices/api/invoices/chequehelper/${storeId}/${supplierId}/`
    );
    return res.data;
  },
  async searchInvoices(params) {
    let request = "/invoices/api/invoices/search/";
    if (params) {
      request += "?";
      if (params.store) {
        request += `store=${params.store}&`;
      }
      if (params.supplier) {
        request += `supplier=${params.supplier}&`;
      }
      if (params.cheque) {
        request += `cheque=${params.cheque}&`;
      }
      if (params.invoice) {
        request += `invoice=${params.invoice}&`;
      }
      if (params.reception) {
        request += `reception=${params.reception}&`;
      }
    }

    const res = await privateInstance.get(mapUrl(request));
    return res.data;
  }
};
